// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bc-color-primary: #0e1b4d;
  --bc-color-primary2: #fff;
  --bc-color-secondary: #fff;
  --bc-color-secondary2: #fff;
  --bc-font-color: #000;
  --bc-font-color2: #fff;
  --bc-default: #f6f8fa;
  .bc-blur-backdrop {
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }
}

/* @tailwind base; */

.bc-fixed {
  position: fixed;
}

.bc-absolute {
  position: absolute;
}

.bc-relative {
  position: relative;
}

.bc-inset-0 {
  inset: 0px;
}

.bc-bottom-0 {
  bottom: 0px;
}

.bc-bottom-\\[0\\] {
  bottom: 0;
}

.bc-bottom-\\[69px\\] {
  bottom: 69px;
}

.bc-left-0 {
  left: 0px;
}

.bc-top-\\[-50px\\] {
  top: -50px;
}

.bc-top-\\[0px\\] {
  top: 0px;
}

.bc-z-10 {
  z-index: 10;
}

.bc-z-50 {
  z-index: 50;
}

.bc-ml-\\[6px\\] {
  margin-left: 6px;
}

.bc-mr-\\[6px\\] {
  margin-right: 6px;
}

.bc-box-border {
  box-sizing: border-box;
}

.\\!bc-flex {
  display: flex !important;
}

.bc-flex {
  display: flex;
}

.\\!bc-hidden {
  display: none !important;
}

.bc-hidden {
  display: none;
}

.bc-h-\\[32px\\] {
  height: 32px;
}

.bc-h-\\[40px\\] {
  height: 40px;
}

.bc-h-\\[43px\\] {
  height: 43px;
}

.bc-h-\\[46px\\] {
  height: 46px;
}

.bc-h-\\[53px\\] {
  height: 53px;
}

.bc-h-\\[60px\\] {
  height: 60px;
}

.bc-h-\\[6px\\] {
  height: 6px;
}

.bc-h-\\[86px\\] {
  height: 86px;
}

.bc-min-h-\\[46px\\] {
  min-height: 46px;
}

.bc-min-h-\\[74px\\] {
  min-height: 74px;
}

.bc-w-\\[32px\\] {
  width: 32px;
}

.bc-w-\\[40px\\] {
  width: 40px;
}

.bc-w-\\[43px\\] {
  width: 43px;
}

.bc-w-\\[46px\\] {
  width: 46px;
}

.bc-w-\\[53px\\] {
  width: 53px;
}

.bc-w-\\[60px\\] {
  width: 60px;
}

.bc-w-\\[68px\\] {
  width: 68px;
}

.bc-w-\\[6px\\] {
  width: 6px;
}

.bc-w-fit {
  width: fit-content;
}

.bc-w-full {
  width: 100%;
}

.bc-min-w-0 {
  min-width: 0px;
}

.bc-min-w-\\[46px\\] {
  min-width: 46px;
}

.bc-max-w-\\[625px\\] {
  max-width: 625px;
}

.bc-flex-1 {
  flex: 1 1 0%;
}

.bc-origin-bottom {
  transform-origin: bottom;
}

.bc-origin-top {
  transform-origin: top;
}

.bc-transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes bc-add-to-bag {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  8.5% {
    transform: scale(1.2);
    opacity: 1;
  }

  17% {
    transform: scale(1);
    opacity: 1;
  }

  85% {
    transform: scale(1);
    opacity: 1;
  }

  96% {
    transform: scale(.2);
    opacity: 0;
  }

  100% {
    transform: scale(0);
    opacity: 0;
  }
}

.bc-animate-addToBag {
  animation: bc-add-to-bag 2s ease 0s 1 normal forwards;
}

@keyframes bc-bc-enter {
  0% {
    opacity: 0.5;
    transform: translateY(100px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.bc-animate-bcenter {
  animation: bc-bc-enter .7s ease-in-out 0s 1;
}

@keyframes bc-bc-pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.bc-animate-bcpulse {
  animation: bc-bc-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.bc-cursor-pointer {
  cursor: pointer;
}

.bc-flex-row {
  flex-direction: row;
}

.bc-flex-col {
  flex-direction: column;
}

.bc-items-center {
  align-items: center;
}

.bc-justify-end {
  justify-content: flex-end;
}

.bc-justify-center {
  justify-content: center;
}

.bc-justify-between {
  justify-content: space-between;
}

.bc-gap-\\[10px\\] {
  gap: 10px;
}

.bc-gap-\\[6px\\] {
  gap: 6px;
}

.bc-overflow-hidden {
  overflow: hidden;
}

.bc-whitespace-nowrap {
  white-space: nowrap;
}

.bc-rounded-\\[6px\\] {
  border-radius: 6px;
}

.bc-rounded-\\[8px\\] {
  border-radius: 8px;
}

.bc-rounded-full {
  border-radius: 9999px;
}

.bc-rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.bc-border {
  border-width: 1px;
}

.bc-border-l-0 {
  border-left-width: 0px;
}

.bc-border-r-0 {
  border-right-width: 0px;
}

.bc-border-t {
  border-top-width: 1px;
}

.bc-border-solid {
  border-style: solid;
}

.bc-border-\\[\\#dcdddc80\\] {
  border-color: #dcdddc80;
}

.bc-bg-\\[\\#dcdddc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 221 220 / var(--tw-bg-opacity));
}

.bc-bg-\\[color\\:var\\(--bc-color-secondary\\)\\] {
  background-color: var(--bc-color-secondary);
}

.bc-bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bc-stroke-\\[color\\:var\\(--bc-color-primary\\)\\] {
  stroke: var(--bc-color-primary);
}

.bc-px-\\[11px\\] {
  padding-left: 11px;
  padding-right: 11px;
}

.bc-px-\\[12px\\] {
  padding-left: 12px;
  padding-right: 12px;
}

.bc-px-\\[8px\\] {
  padding-left: 8px;
  padding-right: 8px;
}

.bc-py-\\[12px\\] {
  padding-top: 12px;
  padding-bottom: 12px;
}

.bc-py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}

.bc-pb-\\[10px\\] {
  padding-bottom: 10px;
}

.bc-pb-\\[15px\\] {
  padding-bottom: 15px;
}

.bc-pr-\\[24px\\] {
  padding-right: 24px;
}

.bc-pt-\\[5px\\] {
  padding-top: 5px;
}

.bc-text-left {
  text-align: left;
}

.bc-font-medium {
  font-weight: 500;
}

.bc-text-\\[color\\:var\\(--bc-color-primary\\)\\] {
  color: var(--bc-color-primary);
}

.bc-shadow-\\[0_-0px_10px_0px_rgba\\(195\\,188\\,188\\,0\\.15\\)\\] {
  --tw-shadow: 0 -0px 10px 0px rgba(195,188,188,0.15);
  --tw-shadow-colored: 0 -0px 10px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.bc-shadow-\\[0_3px_15px_0px_rgba\\(195\\,188\\,188\\,0\\.15\\)\\] {
  --tw-shadow: 0 3px 15px 0px rgba(195,188,188,0.15);
  --tw-shadow-colored: 0 3px 15px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.bc-shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.bc-transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.bc-transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.hover\\:\\!bc-bg-white:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}

.disabled\\:bc-cursor-not-allowed:disabled {
  cursor: not-allowed;
}

@media (min-width: 625px) {
  .tablet\\:\\!bc-flex {
    display: flex !important;
  }

  .tablet\\:\\!bc-hidden {
    display: none !important;
  }
}

@media (min-width: 900px) {
  .desktop\\:bc-top-\\[-59px\\] {
    top: -59px;
  }

  .desktop\\:\\!bc-flex {
    display: flex !important;
  }

  .desktop\\:\\!bc-hidden {
    display: none !important;
  }

  .desktop\\:bc-hidden {
    display: none;
  }

  .desktop\\:bc-h-\\[37px\\] {
    height: 37px;
  }

  .desktop\\:bc-h-\\[48px\\] {
    height: 48px;
  }

  .desktop\\:bc-h-\\[52px\\] {
    height: 52px;
  }

  .desktop\\:bc-h-\\[63\\.6px\\] {
    height: 63.6px;
  }

  .desktop\\:bc-h-\\[72px\\] {
    height: 72px;
  }

  .desktop\\:bc-h-\\[86px\\] {
    height: 86px;
  }

  .desktop\\:bc-w-\\[37px\\] {
    width: 37px;
  }

  .desktop\\:bc-w-\\[48px\\] {
    width: 48px;
  }

  .desktop\\:bc-w-\\[52px\\] {
    width: 52px;
  }

  .desktop\\:bc-w-\\[63\\.6px\\] {
    width: 63.6px;
  }

  .desktop\\:bc-w-fit {
    width: fit-content;
  }

  .desktop\\:bc-gap-\\[10px\\] {
    gap: 10px;
  }

  .desktop\\:bc-gap-\\[8px\\] {
    gap: 8px;
  }

  .desktop\\:bc-px-\\[20px\\] {
    padding-left: 20px;
    padding-right: 20px;
  }

  .desktop\\:bc-px-\\[24px\\] {
    padding-left: 24px;
    padding-right: 24px;
  }

  .desktop\\:bc-pb-\\[5px\\] {
    padding-bottom: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/main.generated.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB;IACE,mCAAmC;IACnC,2BAA2B;EAC7B;AACF;;AAEA,oBAAoB;;AAEpB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+LAA+L;AACjM;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE;IACE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mDAAmD;EACnD,2DAA2D;EAC3D,uGAAuG;AACzG;;AAEA;EACE,kDAAkD;EAClD,0DAA0D;EAC1D,uGAAuG;AACzG;;AAEA;EACE,gFAAgF;EAChF,oGAAoG;EACpG,uGAAuG;AACzG;;AAEA;EACE,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[":root {\n  --bc-color-primary: #0e1b4d;\n  --bc-color-primary2: #fff;\n  --bc-color-secondary: #fff;\n  --bc-color-secondary2: #fff;\n  --bc-font-color: #000;\n  --bc-font-color2: #fff;\n  --bc-default: #f6f8fa;\n  .bc-blur-backdrop {\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n  }\n}\n\n/* @tailwind base; */\n\n.bc-fixed {\n  position: fixed;\n}\n\n.bc-absolute {\n  position: absolute;\n}\n\n.bc-relative {\n  position: relative;\n}\n\n.bc-inset-0 {\n  inset: 0px;\n}\n\n.bc-bottom-0 {\n  bottom: 0px;\n}\n\n.bc-bottom-\\[0\\] {\n  bottom: 0;\n}\n\n.bc-bottom-\\[69px\\] {\n  bottom: 69px;\n}\n\n.bc-left-0 {\n  left: 0px;\n}\n\n.bc-top-\\[-50px\\] {\n  top: -50px;\n}\n\n.bc-top-\\[0px\\] {\n  top: 0px;\n}\n\n.bc-z-10 {\n  z-index: 10;\n}\n\n.bc-z-50 {\n  z-index: 50;\n}\n\n.bc-ml-\\[6px\\] {\n  margin-left: 6px;\n}\n\n.bc-mr-\\[6px\\] {\n  margin-right: 6px;\n}\n\n.bc-box-border {\n  box-sizing: border-box;\n}\n\n.\\!bc-flex {\n  display: flex !important;\n}\n\n.bc-flex {\n  display: flex;\n}\n\n.\\!bc-hidden {\n  display: none !important;\n}\n\n.bc-hidden {\n  display: none;\n}\n\n.bc-h-\\[32px\\] {\n  height: 32px;\n}\n\n.bc-h-\\[40px\\] {\n  height: 40px;\n}\n\n.bc-h-\\[43px\\] {\n  height: 43px;\n}\n\n.bc-h-\\[46px\\] {\n  height: 46px;\n}\n\n.bc-h-\\[53px\\] {\n  height: 53px;\n}\n\n.bc-h-\\[60px\\] {\n  height: 60px;\n}\n\n.bc-h-\\[6px\\] {\n  height: 6px;\n}\n\n.bc-h-\\[86px\\] {\n  height: 86px;\n}\n\n.bc-min-h-\\[46px\\] {\n  min-height: 46px;\n}\n\n.bc-min-h-\\[74px\\] {\n  min-height: 74px;\n}\n\n.bc-w-\\[32px\\] {\n  width: 32px;\n}\n\n.bc-w-\\[40px\\] {\n  width: 40px;\n}\n\n.bc-w-\\[43px\\] {\n  width: 43px;\n}\n\n.bc-w-\\[46px\\] {\n  width: 46px;\n}\n\n.bc-w-\\[53px\\] {\n  width: 53px;\n}\n\n.bc-w-\\[60px\\] {\n  width: 60px;\n}\n\n.bc-w-\\[68px\\] {\n  width: 68px;\n}\n\n.bc-w-\\[6px\\] {\n  width: 6px;\n}\n\n.bc-w-fit {\n  width: fit-content;\n}\n\n.bc-w-full {\n  width: 100%;\n}\n\n.bc-min-w-0 {\n  min-width: 0px;\n}\n\n.bc-min-w-\\[46px\\] {\n  min-width: 46px;\n}\n\n.bc-max-w-\\[625px\\] {\n  max-width: 625px;\n}\n\n.bc-flex-1 {\n  flex: 1 1 0%;\n}\n\n.bc-origin-bottom {\n  transform-origin: bottom;\n}\n\n.bc-origin-top {\n  transform-origin: top;\n}\n\n.bc-transform {\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n@keyframes bc-add-to-bag {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n\n  8.5% {\n    transform: scale(1.2);\n    opacity: 1;\n  }\n\n  17% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  85% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  96% {\n    transform: scale(.2);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(0);\n    opacity: 0;\n  }\n}\n\n.bc-animate-addToBag {\n  animation: bc-add-to-bag 2s ease 0s 1 normal forwards;\n}\n\n@keyframes bc-bc-enter {\n  0% {\n    opacity: 0.5;\n    transform: translateY(100px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.bc-animate-bcenter {\n  animation: bc-bc-enter .7s ease-in-out 0s 1;\n}\n\n@keyframes bc-bc-pulse {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.bc-animate-bcpulse {\n  animation: bc-bc-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.bc-cursor-pointer {\n  cursor: pointer;\n}\n\n.bc-flex-row {\n  flex-direction: row;\n}\n\n.bc-flex-col {\n  flex-direction: column;\n}\n\n.bc-items-center {\n  align-items: center;\n}\n\n.bc-justify-end {\n  justify-content: flex-end;\n}\n\n.bc-justify-center {\n  justify-content: center;\n}\n\n.bc-justify-between {\n  justify-content: space-between;\n}\n\n.bc-gap-\\[10px\\] {\n  gap: 10px;\n}\n\n.bc-gap-\\[6px\\] {\n  gap: 6px;\n}\n\n.bc-overflow-hidden {\n  overflow: hidden;\n}\n\n.bc-whitespace-nowrap {\n  white-space: nowrap;\n}\n\n.bc-rounded-\\[6px\\] {\n  border-radius: 6px;\n}\n\n.bc-rounded-\\[8px\\] {\n  border-radius: 8px;\n}\n\n.bc-rounded-full {\n  border-radius: 9999px;\n}\n\n.bc-rounded-t-2xl {\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n}\n\n.bc-border {\n  border-width: 1px;\n}\n\n.bc-border-l-0 {\n  border-left-width: 0px;\n}\n\n.bc-border-r-0 {\n  border-right-width: 0px;\n}\n\n.bc-border-t {\n  border-top-width: 1px;\n}\n\n.bc-border-solid {\n  border-style: solid;\n}\n\n.bc-border-\\[\\#dcdddc80\\] {\n  border-color: #dcdddc80;\n}\n\n.bc-bg-\\[\\#dcdddc\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(220 221 220 / var(--tw-bg-opacity));\n}\n\n.bc-bg-\\[color\\:var\\(--bc-color-secondary\\)\\] {\n  background-color: var(--bc-color-secondary);\n}\n\n.bc-bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bc-stroke-\\[color\\:var\\(--bc-color-primary\\)\\] {\n  stroke: var(--bc-color-primary);\n}\n\n.bc-px-\\[11px\\] {\n  padding-left: 11px;\n  padding-right: 11px;\n}\n\n.bc-px-\\[12px\\] {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.bc-px-\\[8px\\] {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.bc-py-\\[12px\\] {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.bc-py-\\[5px\\] {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.bc-pb-\\[10px\\] {\n  padding-bottom: 10px;\n}\n\n.bc-pb-\\[15px\\] {\n  padding-bottom: 15px;\n}\n\n.bc-pr-\\[24px\\] {\n  padding-right: 24px;\n}\n\n.bc-pt-\\[5px\\] {\n  padding-top: 5px;\n}\n\n.bc-text-left {\n  text-align: left;\n}\n\n.bc-font-medium {\n  font-weight: 500;\n}\n\n.bc-text-\\[color\\:var\\(--bc-color-primary\\)\\] {\n  color: var(--bc-color-primary);\n}\n\n.bc-shadow-\\[0_-0px_10px_0px_rgba\\(195\\,188\\,188\\,0\\.15\\)\\] {\n  --tw-shadow: 0 -0px 10px 0px rgba(195,188,188,0.15);\n  --tw-shadow-colored: 0 -0px 10px 0px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.bc-shadow-\\[0_3px_15px_0px_rgba\\(195\\,188\\,188\\,0\\.15\\)\\] {\n  --tw-shadow: 0 3px 15px 0px rgba(195,188,188,0.15);\n  --tw-shadow-colored: 0 3px 15px 0px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.bc-shadow-xl {\n  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.bc-transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.bc-transition-opacity {\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.hover\\:\\!bc-bg-white:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;\n}\n\n.disabled\\:bc-cursor-not-allowed:disabled {\n  cursor: not-allowed;\n}\n\n@media (min-width: 625px) {\n  .tablet\\:\\!bc-flex {\n    display: flex !important;\n  }\n\n  .tablet\\:\\!bc-hidden {\n    display: none !important;\n  }\n}\n\n@media (min-width: 900px) {\n  .desktop\\:bc-top-\\[-59px\\] {\n    top: -59px;\n  }\n\n  .desktop\\:\\!bc-flex {\n    display: flex !important;\n  }\n\n  .desktop\\:\\!bc-hidden {\n    display: none !important;\n  }\n\n  .desktop\\:bc-hidden {\n    display: none;\n  }\n\n  .desktop\\:bc-h-\\[37px\\] {\n    height: 37px;\n  }\n\n  .desktop\\:bc-h-\\[48px\\] {\n    height: 48px;\n  }\n\n  .desktop\\:bc-h-\\[52px\\] {\n    height: 52px;\n  }\n\n  .desktop\\:bc-h-\\[63\\.6px\\] {\n    height: 63.6px;\n  }\n\n  .desktop\\:bc-h-\\[72px\\] {\n    height: 72px;\n  }\n\n  .desktop\\:bc-h-\\[86px\\] {\n    height: 86px;\n  }\n\n  .desktop\\:bc-w-\\[37px\\] {\n    width: 37px;\n  }\n\n  .desktop\\:bc-w-\\[48px\\] {\n    width: 48px;\n  }\n\n  .desktop\\:bc-w-\\[52px\\] {\n    width: 52px;\n  }\n\n  .desktop\\:bc-w-\\[63\\.6px\\] {\n    width: 63.6px;\n  }\n\n  .desktop\\:bc-w-fit {\n    width: fit-content;\n  }\n\n  .desktop\\:bc-gap-\\[10px\\] {\n    gap: 10px;\n  }\n\n  .desktop\\:bc-gap-\\[8px\\] {\n    gap: 8px;\n  }\n\n  .desktop\\:bc-px-\\[20px\\] {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .desktop\\:bc-px-\\[24px\\] {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n\n  .desktop\\:bc-pb-\\[5px\\] {\n    padding-bottom: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
